/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { Cart } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCartState,
    getCurrentCartState,
    hasProductsWithInvalidPrice,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    styles?: ButtonPresentationProps;
    cart: Cart;
    
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId, isPlacingOrder, isCheckingOutWithPayPay } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const { sessionId, redirectResult } = parseQueryString<{ sessionId?: string; redirectResult?: string }>(
        getLocation(state).search,
    );
    
    
    return {
        isDisabled:
            cartState.isLoading ||
            isPlacingOrder ||
            isCheckingOutWithPayPay ||
            (!!sessionId && !!redirectResult) ||
            hasProductsWithInvalidPrice(cartState.value) ||
            cartState.value?.hasInsufficientInventory === true,
            cartState,
        };
    };
    
    type Props = OwnProps & ReturnType<typeof mapStateToProps>;
    interface CheckoutReviewSubmitStyles {
        
        warningIcon?: IconPresentationProps;
        warningSection?: InjectableCss;
        warningText?: InjectableCss;
    }
    
    export const checkoutReviewSubmitStyles: CheckoutReviewSubmitStyles = {
     warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: 10px;
        `,
    },
    warningSection: {
        css: css`
            display: flex;
            align-items: center;
            border: 2px solid ${getColor("danger.main")};
            padding: 10px 10px;
            margin-bottom: 5px;
            width: 100%;
            margin-top: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 70%;
                        `,
                        css`
                            max-width: 70%;
                        `,
                        css`
                            max-width: 60% !important;
                        `,
                        css`
                            max-width: 55%;
                        `,
                        css`
                            max-width: 70%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    }
    const styless = checkoutReviewSubmitStyles;
const CheckoutReviewAndSubmitPlaceOrderButton: FC<Props> = ({ isDisabled, styles, cartState }) => {
    const handleClick = () => {
        document.getElementById("reviewAndSubmitPaymentForm-submit")?.click();
        document.getElementById("reviewAndSubmitCarrierServiceForm-submit")?.click();
    };
    const hasSingleInstance = (cartLine: any) => {
        const occurrences = cartLine.filter((item: any) => item?.properties.discontinuedProduct === "true");
        return occurrences.length > 0;
    }

    const isDiscontinuedProductPresent = (cartState?.value?.cartLines && cartState?.value?.cartLines?.length > 0) ? hasSingleInstance(cartState?.value?.cartLines) : false;
    return (
        <>
        <Button
            type="submit"
            disabled={isDisabled || isDiscontinuedProductPresent}
            data-test-selector="checkoutReviewAndSubmit_placeOrder"
            {...styles}
            onClick={handleClick}
        >
            {translate("Place Order")}
        </Button>
        </>
    );
};

export default connect(mapStateToProps)(CheckoutReviewAndSubmitPlaceOrderButton);
